module.exports = __webpack_public_path__ + "static/media/nft-22.79184394.jpg";